// extracted by mini-css-extract-plugin
module.exports = {"basePosition":"BasePosition_basePosition__1ohKb","position":"BasePosition_position__srhis","content":"BasePosition_content__10903","title":"BasePosition_title__2s6EC"};